<svg
        [attr.height]="size"
        [attr.width]="size"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
>
    <path
            [attr.fill]="color"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7V12C11.25 12.2496 11.3737 12.4831 11.5806 12.6247L15.1806 15.1247C15.5217 15.3603 15.9894 15.2758 16.225 14.9347C16.4606 14.5935 16.3761 14.1258 16.0349 13.8903L12.75 11.6099V7Z"
    />
</svg>
